var VersionModal = {};
VersionModal.loadModal = function (productId, settings) {
  settings = settings || {};
  jQuery.ajax({
    url: "/product/" + productId + "/versions",
    method: "get",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (VersionModal.$element) {
        VersionModal.$element.replaceWith(resp.html);
      }
      $("body").append(resp.html);
      VersionModal.$element = $('#chooseSize');
      VersionModal.$element.find(".addVersionToCart").click(function () {
        if (VersionModal.version && settings.onAddToCart) {
          settings.onAddToCart({type: "product", _id: productId, version: VersionModal.version, qty: 1});
          VersionModal.$element.popup("hide");
        }
      });
      VersionModal.$element.find(".sizes label").each(function () {
        var isAvailable = this.getAttribute("data-available") === "true";
        $(this).click(function () {
          if (isAvailable) {
            VersionModal.version = this.getAttribute("data-version");
            $('.error').hide();
            $('.notifyMeAboutVersion').hide();
            $('.addVersionToCart').show();
          } else {
            $('.error').show();
            $('.addVersionToCart').hide();
            $('.notifyMeAboutVersion').show();
          }
        });
      });
      VersionModal.$element.popup('show');
    }
  });
};